var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index618"},[_c('div',{staticClass:"banner"}),_c('img',{attrs:{"src":require("../../assets/img/pc-img2-618.png"),"alt":""}}),_c('img',{attrs:{"src":require("../../assets/img/pc-img3-618.png"),"alt":""}}),_c('img',{attrs:{"src":require("../../assets/img/pc-img4-618.png"),"alt":""}})])
}]

export { render, staticRenderFns }